import { instance } from 'store/utils';
import { types } from './types';
import { downloadFile, downloadRequestHeaders } from 'store/forms/utils';
import { message } from 'antd';
import { triggerLoading } from 'store/forms/actions';

export const react_path = process.env.REACT_APP_PROCESS_APP;

export const getFormData = taskId => dispatch => {
  dispatch({ type: types.GET_FORM_DATA_APP.START });
  instance
    .get(`/app/rest/task-forms/${taskId}/with-vars`)
    .then(response => {
      dispatch({
        type: types.GET_FORM_DATA_APP.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_FORM_DATA_APP.ERROR });
    });
};

export const fetchProcessSAYT = searchKey => dispatch => {
  dispatch({ type: types.FETCH_PROCESS_SAYT.START });
  instance
    .get(`/app/rest/findSAYT?searchKey=` + searchKey)
    .then(response => {
      dispatch({
        type: types.FETCH_PROCESS_SAYT.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.FETCH_PROCESS_SAYT.ERROR });
    });
};

export const getActions = procInstId => dispatch => {
  dispatch({ type: types.GET_ACTIONS.START });
  return instance
    .get(`/app/rest/${procInstId}/actions`)
    .then(response => {
      dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ACTIONS.ERROR });
    });
};

export const getTaskData = taskId => dispatch => {
  dispatch({ type: types.GET_TASK_DATA.START });
  instance
    .get(`/app/rest/tasks/${taskId}`)
    .then(response => {
      dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_TASK_DATA.ERROR });
    });
};

export const fetchRecords = (detailedPayload, page, pageSize) => dispatch => {
  console.log('pageSize  inside is', pageSize);
  console.log('page  inside is', page);
  console.log('parameter list is', detailedPayload);
  dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
  let payload = {
    parameterList: detailedPayload?.parameterList ?? [],
    page,
    pageSize,
  };
  console.log({ payload });
  instance
    .post(`/app/rest/process-instances-paginated`, payload)
    .then(response => {
      const res = response.data.data;
      const resultSize = response?.data?.size;
      const results = Object.keys(res).map(key => ({
        id: key,
        ...res[key],
      }));
      console.log('resultSize in paginated', response);
      dispatch({
        type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
        payload: {
          variables: results,
          resultSize: resultSize,
        },
      });
      // if(!params.isViewMode){
      // dispatch(getFormData(params.taskId));
      // }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
    });
};

export const fetchProcInstancesDetailed = data => dispatch => {
  dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
  instance
    .post(`/app/rest/process-instances-apptrack`, data)
    .then(response => {
      const res = response.data.data;
      const results = Object.keys(res).map(key => ({
        id: key,
        ...res[key],
      }));
      dispatch({
        type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
        payload: {
          variables: results,
        },
      });
      // if(!params.isViewMode){
      // dispatch(getFormData(params.taskId));
      // }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
    });
};

export const getBannerInfo = () => dispatch => {
  dispatch({ type: types.BANNER_INFO.START });
  instance
    .get(`/app/rest/configurations/getByCode?code=bannerRender`)
    .then(response => {
      if (response?.data?.value === true) {
        instance
          .get(`/app/rest/configurations/getByCode?code=bannerMessage`)
          .then(response2 =>
            dispatch({
              type: types.BANNER_INFO.SUCCESS,
              payload: { render: true, message: response2?.data?.value },
            })
          )
          .catch(err => console.log(err));
      } else {
        dispatch({
          type: types.BANNER_INFO.SUCCESS,
          payload: { render: false, message: '' },
        });
      }
    })
    .catch(() => {
      dispatch({ type: types.BANNER_INFO.ERROR });
    });
};

export const clearApptrack = () => dispatch => {
  dispatch({ type: types.CLEAR_APPTRACK.SUCCESS });
};

export const clearApptrackDetails = () => dispatch => {
  dispatch({ type: types.CLEAR_APPTRACK_DETAILS.SUCCESS });
};

export const clearSayt = () => dispatch => {
  dispatch({ type: types.CLEAR_SAYT });
};

export const navigateToView = (navigate, processInstanceId) => {
  navigate(`/apptrack/${processInstanceId}`);
};

export const navigateToViewOnly = (navigate, processInstanceId) => {
  navigate(`/apptrack/disabled/${processInstanceId}`);
};

export const cancelProcessInstance = procInstId => dispatch => {
  console.log('bike sto cancel stin klish');
  dispatch({ type: types.CANCEL_PROCESS.START });
  instance
    .get(`/app/rest/cancel-process-instance/${procInstId}`)
    .then(response => {
      dispatch({ type: types.CANCEL_PROCESS.SUCCESS, payload: response.data });
      window.location.reload();
    })
    .catch(error => {
      dispatch({ type: types.CANCEL_PROCESS.ERROR, error });
    });
};

export const getDetails = processInstanceId => {
  return instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
    .then(response => {
      return response.data.variablesIndexed;
    });
};

export const getApptrackDetails = processInstanceId => dispatch => {
  dispatch({ type: types.GET_APPTRACK_DETAILS.START });

  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
    .then(response => {
      // console.log("RESPONSE",response.data);
      dispatch({
        type: types.GET_APPTRACK_DETAILS.SUCCESS,
        payload: {
          activeTaskName: response.data.activeTaskName,
          activeTaskId: response.data.activeTaskId,
          id: response.data.id,
          businessKey: response.data.businessKey,
          variablesIndexed: response.data.variablesIndexed,
          localTaskVariables: response.data.localTaskVariables,
          contentItems: response.data.contentItems,
          comments: response.data.comments,
        },
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_APPTRACK_DETAILS.ERROR });

      console.log(error, 'error');
    });
};

export const getOffersHistory = () => dispatch => {
  dispatch({ type: types.GET_OFFERS_HISTORY.START });

  instance
    .get(`/app/rest/offers/uploads`)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.GET_OFFERS_HISTORY.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_OFFERS_HISTORY.ERROR });

      console.log(error, 'error');
    });
};

export const uploadOffers =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.UPLOAD_OFFERS.START });

    instance
      .post(`/app/rest/offers/upload`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_OFFERS.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_OFFERS.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

export const downloadUploadedFilev2 = fileInfo => dispatch => {
  message.loading('Αναμονή λήψης αρχείου');
  dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.START });
  instance
    .get(`/app/rest/downloadFile?fileId=${fileInfo?.id}`, {
      responseType: 'blob',
    })
    .then(response => {
      //create hidden anchor and click behind the scenes to trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = fileInfo?.filename;
      link.click();
      dispatch({
        type: types.DOWNLOAD_UPLOADED_FILE.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.ERROR });
      // message.error("Σφάλμα κατά τη λήψη του αρχείου");
    });
};

export const getActiveOffers =
  (infrprov = '') =>
  dispatch => {
    dispatch({ type: types.GET_ACTIVE_OFFERS.START });

    instance
      .get(`/app/rest/offers/getAll${infrprov ? `/${infrprov}` : ''}`)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.GET_ACTIVE_OFFERS.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ACTIVE_OFFERS.ERROR });

        console.log(error, 'error');
      });
  };

export const clearActiveOffers = () => dispatch => {
  dispatch({ type: types.CLEAR_ACTIVE_OFFERS.SUCCESS, payload: {} });
};

export const openUploadOffersModal = open => dispatch => {
  dispatch({ type: types.OPEN_UPLOAD_OFFERS_MODAL.SUCCESS, payload: open });
};
export const openMassUploadSubmitModal = open => dispatch => {
  dispatch({ type: types.OPEN_UPLOAD_PROVIDER_MODAL.SUCCESS, payload: open });
};
export const setSelectedOffersFileFlag = selected => dispatch => {
  dispatch({ type: types.SET_SELECTED_OFFERS_FILE.SUCCESS, payload: selected });
};
export const setSelectedMassUploadFileFlag = selected => dispatch => {
  dispatch({
    type: types.SET_SELECTED_MASS_UPLOAD_FILE.SUCCESS,
    payload: selected,
  });
};

export const setApptrackLoading = () => dispatch => {
  dispatch({ type: types.SET_APPTRACK_LOADING });
};

export const getAllTaskNames = () => dispatch => {
  dispatch({ type: types.GET_ALL_TASK_NAMES.START });

  instance
    // .get(`/app/rest/all-task-names`)
    .get(`/app/rest/all-task-names-indexed`)
    .then(response => {
      dispatch({
        type: types.GET_ALL_TASK_NAMES.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });

      console.log(error, 'error');
    });
};

export const addCommentOldImplementation = (id, data) => dispatch => {
  //process-instance-based
  const payload = {
    id: '',
    message: data,
    created: '',
    createdBy: '',
  };

  return instance
    .post(`/app/rest/process-instances/${id}/comments`, payload)
    .then(response => {
      console.log('RESPONSE:', response.data);
      // dispatch({
      //   type: types.GET_ALL_TASK_NAMES.SUCCESS,
      //   payload: response.data,
      // });
    })
    .catch(error => {
      // dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });
      console.log(error, 'error');
    });
};

export const addComment = (id, data) => dispatch => {
  //task-based
  const payload = {
    id: '',
    message: data,
    created: '',
    createdBy: '',
  };

  return instance
    .post(`/app/rest/${id}/comments`, payload)
    .then(response => {
      console.log('RESPONSE:', response.data);
      // dispatch({
      //   type: types.GET_ALL_TASK_NAMES.SUCCESS,
      //   payload: response.data,
      // });
    })
    .catch(error => {
      // dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });
      console.log(error, 'error');
    });
};

export const uploadReserveRedeeem =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.UPLOAD_PROVIDER.START });
    instance
      .put(`/app/rest/providers/mass-reserve`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_PROVIDER.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_PROVIDER.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

export const uploadMassPaymentrequest =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.UPLOAD_PROVIDER_PR.START });
    instance
      .put(`/app/rest/providers/payment-request`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_PROVIDER_PR.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_PROVIDER_PR.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };
export const ktpMassUpload =
  ({ file, callback }) =>
  dispatch => {
    dispatch({ type: types.KTP_MASS_UPLOAD.START });
    instance
      .put(`/app/rest/ktp/mass-upload`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.KTP_MASS_UPLOAD.SUCCESS,
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.KTP_MASS_UPLOAD.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

export const getProviderHistory = () => dispatch => {
  dispatch({ type: types.GET_PROVIDER_HISTORY.START });

  instance
    .get(`/app/rest/providers/uploads`)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.GET_PROVIDER_HISTORY.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_PROVIDER_HISTORY.ERROR });
      console.log(error, 'error');
    });
};

export const getPaymentsHistory = (type, param) => dispatch => {
  dispatch({ type: types.GET_PAYMENTS_HISTORY.START });

  instance
    .get(
      `/app/rest/${type}/${type === 'providers' ? `payment-` : ''}uploads${param ? `?fileType=${param}` : ''}`
    )
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.GET_PAYMENTS_HISTORY.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_PAYMENTS_HISTORY.ERROR });
      console.log(error, 'error');
    });
};

export const getProviderHistoryExcelDetail =
  (fileInfo, params, pr = false) =>
  dispatch => {
    message.loading('Αναμονή λήψης αρχείου');
    const status = params;
    console.log({ status });
    dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.START });
    instance
      .post(
        `/app/rest/providers/${pr ? 'payment-' : ''}details?fieldId=${fileInfo?.id}`,
        { status },
        { responseType: 'blob' }
      )
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = status + '_' + fileInfo?.filename;
        link.click();
        dispatch({
          type: types.GET_PROVIDER_HISTORY_DETAILS.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };
export const getKtpHistoryExcelDetail =
  (fileInfo, params, pr = false) =>
  dispatch => {
    message.loading('Αναμονή λήψης αρχείου');
    const status = params;
    console.log({ status });
    dispatch({ type: types.GET_KTP_HISTORY_DETAILS.START });
    instance
      .post(
        `/app/rest/ktp/details?fieldId=${fileInfo?.id}`,
        { status },
        { responseType: 'blob' }
      )
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = status + '_' + fileInfo?.filename;
        link.click();
        dispatch({
          type: types.GET_KTP_HISTORY_DETAILS.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_KTP_HISTORY_DETAILS.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };

export const approvePayment = (param, payload, callback) => dispatch => {
  dispatch({ type: types.APPROVE_PAYMENT.START });

  instance
    .post(`/app/rest/ktp/payment-approval?fieldId=${param}`, payload)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.APPROVE_PAYMENT.SUCCESS,
        payload: response.data,
      });
      callback();
    })
    .catch(error => {
      dispatch({ type: types.APPROVE_PAYMENT.ERROR });
      console.log(error, 'error');
    });
};

export const rejectPayment = (param, payload, callback) => dispatch => {
  dispatch({ type: types.REJECT_PAYMENT.START });
  instance
    .post(`/app/rest/ktp/payment-reject?fieldId=${param}`, payload)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.REJECT_PAYMENT.SUCCESS,
        payload: response.data,
      });
      callback();
    })
    .catch(error => {
      dispatch({ type: types.REJECT_PAYMENT.ERROR });
      console.log(error, 'error');
    });
};

export const partiallyApprovePayment =
  (param, payload, callback) => dispatch => {
    dispatch({ type: types.PARTIAL_PAYMENT.START });
    instance
      .post(`/app/rest/ktp/payment-partial-approval`, payload)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.PARTIAL_PAYMENT.SUCCESS,
          payload: response.data,
        });
        callback();
      })
      .catch(error => {
        dispatch({ type: types.PARTIAL_PAYMENT.ERROR });
        console.log(error, 'error');
      });
  };

export const updateFile = (id, payload) => dispatch => {
  dispatch({ type: types.UPDATE_FILE.START });
  return instance
    .post(`/app/rest/tasks/${id}/raw-contents`, payload)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.UPDATE_FILE.SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    })
    .catch(error => {
      dispatch({ type: types.UPDATE_FILE.ERROR });
      console.log(error, 'error');
      dispatch(triggerLoading(false));
      return { success: false, error };
    });
};

export const updateFinancial = (id, payload, navigate) => dispatch => {
  dispatch({ type: types.UPDATE_GENERATE.START });
  return instance
    .post(`/app/rest/update-financial-model/${id}`, payload)
    .then(response => {
      console.log(response.data);
      dispatch(triggerLoading(false));
      dispatch({
        type: types.UPDATE_GENERATE.SUCCESS,
        payload: response.data,
      });
      localStorage.setItem('showUpdateModal', true);
      navigate('/appTrack');
      return { success: true, data: response.data };
    })
    .catch(error => {
      dispatch({ type: types.UPDATE_GENERATE.ERROR });
      console.log(error, 'error');
      dispatch(triggerLoading(false));
      return { success: false, error };
    });
};

export const updateEligibility = (id, payload, navigate) => dispatch => {
  dispatch({ type: types.UPDATE_GENERATE.START });
  return instance
    .post(`/app/rest/update-eligibility-excel/${id}`, payload)
    .then(response => {
      console.log(response.data);
      dispatch(triggerLoading(false));
      dispatch({
        type: types.UPDATE_GENERATE.SUCCESS,
        payload: response.data,
      });
      localStorage.setItem('showUpdateModal', true);
      navigate('/appTrack');
      return { success: response.data.success, data: response.data };
    })
    .catch(error => {
      dispatch(triggerLoading(false));
      dispatch({ type: types.UPDATE_GENERATE.ERROR });
      console.log(error, 'error');
      return { success: false, error };
    });
};

export const getUpdateError = taskId => dispatch => {
  dispatch({ type: types.GET_UPDATE_ERROR.START });
  return instance
    .get(`/app/rest/error-details/${taskId}`)
    .then(response => {
      dispatch({
        type: types.GET_UPDATE_ERROR.SUCCESS,
        payload: response.data,
      });
      return response.data;
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_UPDATE_ERROR.ERROR });
      return { errorLabel: 'Something went wrong' };
    });
};

export const updateApptrackField = payload => dispatch => {
  console.log('PAYLOAD:', payload);
  dispatch({ type: types.UPDATE_APPTRACK_FIELD, payload });
};
